import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    Modal,
} from "react-bootstrap";

import { INTRO_POPUP_UPDATE } from '../../../../../../actions/sceneActions'

class IntroModal extends React.Component {
    constructor(props) {
        super();
    }

    state = {
        show: true
    };

    componentDidMount() {

    }

    closeButtonAction = event => {
        const { wallID } = this.props;
        this.setState({ show: false }, () => this.props.INTRO_POPUP_UPDATE(wallID))
    }

    onGetStartedStudio = event => {
        const { wallID } = this.props;
        this.setState({ show: false }, () => this.props.INTRO_POPUP_UPDATE(wallID))

    }

    render() {
        const { wallID, showModal } = this.props;
        //console.log('props', showModal)
        const { show } = this.state;

        return (
            <Modal size="lg" aria-labelledby="contained-modal-title-vcenter" className="intro_modal" centered show={show}>
                <button className="btn p-2 btn-text intro_close fixed-top" onClick={this.closeButtonAction}>
                    <i className="ki ki-close icon-1x pr-0 text-light opacity-60 hover-opacity-80"></i>
                </button>
                <div className="modal-body p-0 w-100">
                    <iframe className="intro_video" src="https://player.vimeo.com/video/589330860?h=fe7a892771" width="1000" height="450" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
                    <div className="slide_action d-flex flex-column align-items-center px-5 py-5 justify-content-center">
                        <button className="btn btn-primary mb-2 btn-min-w" onClick={this.onGetStartedStudio}>Getting Started</button>
                    </div>
                </div>
            </Modal>
        )
    }
}


const mapStateToProps = state => {
    return {
       // layouts: state.layout.layouts
    }
}
const mapDispatchToProps = dispatch => {
    return {
        INTRO_POPUP_UPDATE: (wallID) => dispatch(INTRO_POPUP_UPDATE(wallID)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(IntroModal);
